import React from "react";
import {
  Box,
  Container,
  HStack,
  Button,
  useColorMode,
  Image,
  IconButton,
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
} from "@chakra-ui/react";
import { Link, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { MoonIcon, SunIcon } from "@chakra-ui/icons";
import { FiGlobe, FiGrid, FiUser } from "react-icons/fi";
import { useLanguageStore } from "../../stores/languageStore";
import { Text } from "@chakra-ui/react";
export const PublicNavbar: React.FC = () => {
  const { colorMode, toggleColorMode } = useColorMode();
  const navigate = useNavigate();
  const { t: translate, i18n } = useTranslation();
  const { setLanguage } = useLanguageStore();

  const handleLanguageChange = (lang: "en" | "pt-BR" | "es-AR") => {
    setLanguage(lang);
    i18n.changeLanguage(lang);
  };

  return (
    <Box
      as="nav"
      position="fixed"
      w="full"
      zIndex={1000}
      bg={
        colorMode === "dark" ? "rgba(26, 32, 44, 1)" : "rgba(255, 255, 255, 1)"
      }
      backdropFilter="blur(10px)"
      borderBottom="1px"
      borderColor={colorMode === "dark" ? "gray.700" : "gray.200"}
    >
      {/* <Box bg={colorMode === "dark" ? "gray.900" : "gray.100"} w="full">
        <Container maxW="container.lg" py={2}>
          <HStack>
            <Text fontSize="sm" color="gray.500">
              {translate("home.soonLaunch")}
            </Text>
          </HStack>
        </Container>
      </Box> */}
      <Container maxW="container.lg" py={2}>
        <HStack justify="space-between">
          <Link to="/">
            <Image
              src={`./assets/img/logo-${
                colorMode === "dark" ? "circle-dark" : "circle-light"
              }.svg`}
              display={{ base: "block", md: "none" }}
              alt="Araria"
              height="32px"
            />
            <Image
              src={`./assets/img/logo-hor-${
                colorMode === "dark" ? "dark" : "light"
              }.svg`}
              display={{ base: "none", md: "block" }}
              alt="Araria"
              height="32px"
              fallback={<Text>Araria</Text>}
            />
          </Link>
          <HStack spacing={4}>
            {/* Language Selector */}
            <Menu>
              <MenuButton
                as={IconButton}
                icon={<FiGlobe />}
                variant="ghost"
                aria-label="Change language"
                color={colorMode === "dark" ? "white" : "gray.800"}
              />
              <MenuList>
                <MenuItem onClick={() => handleLanguageChange("en")}>
                  {translate("settings.english")}
                </MenuItem>
                <MenuItem onClick={() => handleLanguageChange("pt-BR")}>
                  {translate("settings.portuguese")}
                </MenuItem>
                <MenuItem onClick={() => handleLanguageChange("es-AR")}>
                  {translate("settings.spanish")}
                </MenuItem>
              </MenuList>
            </Menu>

            {/* Theme Toggle */}
            <IconButton
              aria-label="Toggle theme"
              icon={colorMode === "dark" ? <SunIcon /> : <MoonIcon />}
              onClick={toggleColorMode}
              variant="ghost"
              color={colorMode === "dark" ? "white" : "gray.800"}
            />

            {/* Auth Buttons */}
            {localStorage.getItem("token") ? (
              <IconButton
                aria-label="Chat"
                variant="ghost"
                onClick={() => navigate("/dashboard")}
                color={colorMode === "dark" ? "white" : "gray.800"}
                icon={<FiGrid />}
              />
            ) : (
              <Button
                variant="ghost"
                onClick={() => navigate("/login")}
                color={colorMode === "dark" ? "white" : "gray.800"}
              >
                {translate("navigation.login")}
              </Button>
            )}
            <Button
              bg="brand.primary"
              color="black"
              _hover={{
                bg: "brand.secondary",
                color: "white",
              }}
              onClick={() => navigate("/pricing")}
            >
              {translate("home.hero.cta")}
            </Button>
          </HStack>
        </HStack>
      </Container>
    </Box>
  );
};
